import { render, staticRenderFns } from "./KeywordsList.vue?vue&type=template&id=3bff5cde"
import script from "./KeywordsList.vue?vue&type=script&lang=js"
export * from "./KeywordsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports